<div class="card">
    <div class="card-header flex justify-between items-center">
      <div class="exp">
        <h4 class="text-lg font-semibold">Tax invoice and additional documents</h4>
        <p>
          Tax invoice and additional documents for all applicable service providers
          <strong>{{ invoices.length }}</strong>
        </p>
        <p>Total number of documents <strong>{{ invoices.length }}</strong></p>
      </div>
    </div>
  
    <div class="card-body">
      <div class="input-group mb-4 w-50 mt-4">
        <span class="input-group-text bg-white border-end-0">
          <i class="fa-solid fa-magnifying-glass text-muted"></i>
        </span>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          class="form-control border-start-0"
          placeholder="Filter by service providers, document type or other properties"
        />
      </div>
  
      <table class="table table-striped table-bordered table-hover">
        <thead class="thead-light">
          <tr>
            <th
              *ngFor="let header of headers"
              (click)="sortBy(header.key)"
              class="cursor-pointer"
            >
              {{ header.label }} ⬍
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let invoice of filteredInvoices">
            <td *ngFor="let header of headers">
              {{ invoice[header.key] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  